import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { Client } from '../../models/client.model';
import { ClientService } from '../../services/client.service';
import { AuthenticationService } from '../../core/authentication/auth.service';
import { ModuleConfigurationService } from '../../services/configuration.service';
import { toId } from '../../utils/common.utils';

@Component({
  selector: 'nli-client',
  templateUrl: './nli-client.component.html',
  styleUrls: ['./nli-client.component.scss']
})
export class ClientComponent implements OnInit {
  loading = true;
  username: string;
  client: Client;
  isEmpty: boolean;
  errorMessage: string;
  clientForm: FormGroup;
  keycloakEnabled: boolean;

  clients: any;

  toId = toId;

  get authenticated() {
    return this.clientService.isLoggedIn();
  }

  constructor(
    private clientService: ClientService,
    private router: Router,
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    @Optional() private moduleConfigurator: ModuleConfigurationService
  ) {
    this.clientForm = fb.group({
      client: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.keycloakEnabled =
      this.authenticationService &&
      this.authenticationService.keycloakSetting &&
      this.authenticationService.keycloakSetting.enabled;
    this.client = new Client('');
    this.isEmpty = true;


    this.authenticated.subscribe((authenticated: boolean) => {
      if (authenticated) {
        this.postLoginHandler();
      } else {
        if (!this.keycloakEnabled) {
          this.router.navigate(['/loginpage']);
        }
      }
    });
  }


  postLoginHandler(): void {
    if (this.moduleConfigurator?.options?.skipClientSelection) {
      this.router.navigate(['/loggedIn']);
    } else {
      this.loadClients();
    }
  }


  loadClients() {
    this.authenticationService.getCurrentUserName().subscribe(userName => {
      this.username = userName;
    });
    const clients$ = this.keycloakEnabled ? this.clientService.getClientsKeycloak() : this.clientService.getClients();
    clients$
      .pipe(
        map((clients: string[]): any[] => {
          return clients.sort((a, b) => a.toString().toLowerCase().localeCompare(b.toString().toLowerCase())).map((client: string) => {
            return {
              label: client.toString(),
              value: client.toString()
            };
          });
        })
      )
      .subscribe((clients: Client[]) => {
        this.clients = clients;
        this.loading = false;
      });
  }

  gotoNextPage() {
    this.client = new Client(this.clientForm.value.client);
    this.clientService.resetClient(this.client, 1);
    this.router.navigate(['/loggedIn']);
  }

  logout() {
    this.clientService.logout();
    this.router.navigate(['/loginpage']);
  }
}
